import ComponentElement from 'components/component-element';
import {createElement, setCookie, getCookie} from 'methods/utils';

function CookiesConsent($element, options = {}) {
    this.cookieName = 'cookies_consent';

    if (getCookie(this.cookieName) || !$element) {
        return;
    }

    ComponentElement.call(this, $element, options);

    this.$item = createElement(`
        <div class="CookiesConsent__item">
            <div class="CookiesConsent__item-text">
                Используем куки, чтобы поиск жилья был еще удобнее. <a class="CookiesConsent__item-link" href="/about/obrabotka_personalnyh_dannyh/" target="_blank">Узнать подробнее</a>
            </div>
            <button class="CookiesConsent__item-accept js-accept-button" type="button">Принять</button>
        </div>
    `);

    this.acceptButton = this.$item.querySelector('.js-accept-button');

    this._bindedAccept = this._accept.bind(this); 

    this.acceptButton.addEventListener('click', this._bindedAccept);

    this._create();
}

CookiesConsent.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(CookiesConsent.prototype, 'constructor', {
    value: CookiesConsent,
    enumerable: false,
    writable: true,
});

CookiesConsent.prototype._create = function() {
    this.$element.insertAdjacentElement('afterbegin', this.$item);
}

CookiesConsent.prototype._remove = function() {
    this.$item.remove();
}

CookiesConsent.prototype._accept = function() {
    this._consent();

    this._remove();

    this.acceptButton.removeEventListener('click', this._bindedAccept);
}

// пользователь согласился с использованием куки
CookiesConsent.prototype._consent = function() {
    setCookie(this.cookieName, 1, 365);
}

export default CookiesConsent;